const mapStateToProps = state => {
    return {
        callcenterSearch: state.searchReducer,
    };
};

export { mapStateToProps };
